export const onServiceWorkerUpdateFound = () => {
  window.location.reload()
}
